type TravelMode = (typeof TRAVEL_MODES)[number];

const TRAVEL_MODES = [
  'walk',
  'bike',
  'car',
  'bus',
  'rail',
  'ship',
  'airplane',
  'other',
] as const;

export type { TravelMode };
export { TRAVEL_MODES };
